import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18n';

export const Tip = ({ subText }) => {
  return (
    <div className="read-security-container">
      <div className="warning-contents">
        <div className="text-box">
          <h1 className="sub-main-text">{i18n.t('BTY_W_T_TIP')}</h1>
          <p className="sub-text">{subText}</p>
        </div>
      </div>
    </div>
  );
};

Tip.propTypes = {
  subText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};
Tip.defaultProps = {
  subText: null,
};
export default Tip;
